<template>
    <div class="spotlight-result-item" :class="{ 'spotlight-result-item--focused': focused }" @click="$emit('select', item)">
        <div class="spotlight-result-icon spotlight-result-icon--filefolder">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
        </div>
        <div class="spotlight-result-text">
            <div class="spotlight-result-title">
                <span v-if="item.meta?.color" class="spotlight-result-dot" :style="{ background: item.meta.color }"></span>
                <span class="spotlight-result-title-text">{{ item.title }}</span>
            </div>
            <div v-if="isSubfolder" class="spotlight-result-subtitle">{{ $t('common.spotlight.subfolder') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FileFolderResult',
    props: { item: Object, focused: Boolean },
    emits: ['select'],
    computed: {
        isSubfolder() {
            return this.item.meta?.parent_id != null
        }
    }
}
</script>
